import { QuotationTaskDocument } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1540. 見積タスクファイル一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const quotationTaskDocuments = (props: Props): Promise<QuotationTaskDocument[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_documents`
  );
};

export const useQuotationTaskDocuments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => quotationTaskDocuments(props)
  });
};

export const useQuotationTaskDocumentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
}

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'sales_orders',
    props.sales_order_id,
    'quotation_tasks',
    props.task_id,
    'quotation_task_documents',
  ];
};
